<template>
	<div>
		<CRow alignHorizontal="between">
			<CCol class="col-sm-3 d-flex justify-content-start align-items-center">
				<CButton color="warning" @click="$emit('goto', 1)">
					<CIcon class="text-white" name="cil-arrow-left" />
					<span class="ml-3 align-middle text-white">Suspendre</span>
				</CButton>
			</CCol>
			<CCol class="col-sm-4 d-flex justify-content-end align-items-center">
				<CButton @click="openWaitingPackagesModal" color="secondary" class="mr-3">
					<span>Liste des colis en attente</span>
				</CButton>

				<CButton @click="closeProduction" color="danger">
					<span>Clôturer</span>
				</CButton>
			</CCol>
		</CRow>
		<CRow alignHorizontal="center" class="mt-5">
			<h3>Production pour la LTA : {{ production.flight.LTA }}</h3>
		</CRow>
		<CRow alignHorizontal="center">
			<CCol v-for="limit in getFlightLimits" :sm="12 / getFlightLimits.length">
				<div class="progress-bar-container mb-2" v-for="(type, name) in stats.flight">
					<h5>
						<span v-if="name === 'total'" class="progress-label"
							>Limite {{ limit.unitLabel }} :</span
						>
						<span v-else-if="name === 'colipays'" class="progress-label">Colipays :</span>
						<span v-else-if="name === 'colikado'" class="progress-label">Colikado :</span>
						{{ type[limit.unit].toLocaleString() }} / {{ limit.value.toLocaleString() }}
						{{ limit.unitLabel }}
					</h5>
					<CProgress
						:value="type[limit.unit]"
						:color="name === 'total' ? 'info' : name === 'colipays' ? 'primary' : 'danger'"
						:max="limit.value"
						animated
						showPercentage
					/>
				</div>
			</CCol>
		</CRow>
		<hr />
		<CRow alignHorizontal="center">
			<h3>Palette en cours : {{ this.production.pallet.reference }}</h3>
		</CRow>
		<CRow class="my-3" alignHorizontal="center" alignVertical="center">
			<SwitchPalletForm :production="production" v-on:submit="updatePallet" />
		</CRow>
		<CRow alignHorizontal="center">
			<CCol v-for="limit in getPalletLimits" :sm="12 / getPalletLimits.length">
				<div class="progress-bar-container mb-2" v-for="(type, name) in stats.pallet">
					<h5>
						<span v-if="name === 'total'" class="progress-label"
							>Limite {{ limit.unitLabel }} :</span
						>
						<span v-else-if="name === 'colipays'" class="progress-label">Colipays :</span>
						<span v-else-if="name === 'colikado'" class="progress-label">Colikado :</span>
						{{ type[limit.unit].toLocaleString() }} / {{ limit.value.toLocaleString() }}
						{{ limit.unitLabel }}
					</h5>
					<CProgress
						:value="type[limit.unit]"
						:color="name === 'total' ? 'info' : name === 'colipays' ? 'primary' : 'danger'"
						:max="limit.value"
						animated
						showPercentage
					/>
				</div>
			</CCol>
		</CRow>
		<hr />
		<div class="table-responsive">
			<table class="table table-borderless col-sm-12 table-striped">
				<thead>
					<tr>
						<th scope="col">Nom</th>
						<th scope="col">Référence</th>
						<th scope="col">Ajouté le</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="packages" v-for="(command, index) in packages" :key="index">
						<td class="col-4">{{ command.name }}</td>
						<td class="col-4">{{ command.shippingNumber }}</td>
						<td class="col-4">
							{{ $moment(command.scannedAt.date).format('DD/MM/YYYY HH:mm:ss') }}
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<packages-details-modal-production
			ref="detailsModal"
			:title="`Liste des colis non-scannés pour la date d'envoie du ${getDepartureTime}`"
			@updateModal="$emit('updateModal', $event)"
		/>
	</div>
</template>

<script>
	import SwitchPalletForm from './SwitchPalletForm';
	import mercure from '../../../../components/ghostlexly-components/libs/mercure';
	import PackagesDetailsModalProduction from '../../../_components/packages-details-modal-production';

	export default {
		components: { PackagesDetailsModalProduction, SwitchPalletForm },
		props: {
			production: Object,
		},
		data: function () {
			return {
				stats: {
					flight: {
						total: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
						colikado: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
						colipays: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
					},
					pallet: {
						total: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
						colikado: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
						colipays: {
							weight: 0,
							volume: 0,
							quantity: 0,
						},
					},
				},
				packages: [],
			};
		},
		computed: {
			getDepartureTime() {
				return this.$moment(this.production.flight.departureTime).format('DD/MM/YYYY');
			},
			getDate() {
				return this.$moment(this.production.flight.departureTime).format('YYYY-MM-DD');
			},
			getFlightLimits: function () {
				let limits = [];
				if (this.production.flight.weightLimit !== undefined) {
					limits.push({
						unit: 'weight',
						unitLabel: 'Kg',
						value: this.production.flight.weightLimit,
					});
				}

				if (this.production.flight.volumeLimit !== undefined) {
					limits.push({
						unit: 'volume',
						unitLabel: 'Uv',
						value: this.production.flight.volumeLimit,
					});
				}

				if (this.production.flight.quantityLimit !== undefined) {
					limits.push({
						unit: 'quantity',
						unitLabel: 'Nb',
						value: this.production.flight.quantityLimit,
					});
				}

				return limits;
			},

			getPalletLimits: function () {
				let limits = [];

				if (this.production.pallet.weightLimit !== undefined) {
					limits.push({
						unit: 'weight',
						unitLabel: 'Kg',
						value: this.production.pallet.weightLimit,
					});
				}

				if (this.production.pallet.volumeLimit !== undefined) {
					limits.push({
						unit: 'volume',
						unitLabel: 'Uv',
						value: this.production.pallet.volumeLimit,
					});
				}

				if (this.production.pallet.quantityLimit !== undefined) {
					limits.push({
						unit: 'quantity',
						unitLabel: 'Nb',
						value: this.production.pallet.quantityLimit,
					});
				}

				return limits;
			},
		},

		methods: {
			updatePallet(production) {
				this.$emit('update:production', production);
			},

			getStats() {
				mercure.watch(this, '/api/productions/{id}', function () {
					this.$axios.get(this.production['@id'] + '/live').then(res => {
						this.stats = res.data.stats;
						this.packages = res.data.packages;
					});
				});
			},

			closeProduction() {
				if (confirm('Êtes-vous sûr de vouloir clôturer cette production ?')) {
					this.$axios
						.patch(
							this.production['@id'] + '/close',
							{},
							{
								headers: {
									'Content-Type': 'application/merge-patch+json',
								},
							}
						)
						.then(res => {
							if (res.status === 200) {
								this.$toast.success(
									'Production clôturé avec succès, vous allez être redirigé'
								);
								setTimeout(() => {
									this.$emit('goto', 1);
								}, 2000);
							}
						})
						.catch(err => {
							this.$toast.error(
								"La production n'a pas pu être clôturé, veuillez contactez un administrateur"
							);
						});
				}
			},

			async openWaitingPackagesModal() {
				this.$refs.detailsModal.loadData(this.getDate);
				this.$refs.detailsModal.showModal = true;
			},
		},
		mounted() {
			this.getStats();
		},
	};
</script>
